import {PaginaLogada} from "../../componentes";
import {useEffect, useMemo, useState} from "react";
import {
  Badge,
  Button,
  Card,
  Center,
  Chip,
  Divider,
  Grid,
  Group,
  Tabs,
  Text,
  Title,
  Tooltip
} from '@mantine/core';
import {BarChart, PieChart} from '@mantine/charts';
import {MRT_Localization_PT_BR} from 'mantine-react-table/locales/pt-BR';
import {Forca} from "../../tipos/forca";
import SelectFetchMantine from "../../componentes/form/select-fetch-mantine";
import {IconFileAlert, IconFileDollar, IconSearch} from "@tabler/icons-react";
import {MantineReactTable, MRT_ColumnDef} from "mantine-react-table";
import classes from "./dashboard.module.css"
import {DateInput} from "@mantine/dates";
import {PieChartCell} from "@mantine/charts/lib/PieChart/PieChart";
import {COL_RESP_3, COR, HttpVerbo, LOCAL_DATE_STRING} from "../../config/constantes/constantes-mantine";
import {BarChartSeries} from "@mantine/charts/lib/BarChart/BarChart";
import ForcaServico from "../../servicos/forca-servico";
import {getForca} from "../../util/util";
import { formatarDinheiroItl } from "../../util";
import {xfetch} from "../../util";

interface DadosDash {
  id: number;
  nome: string;
  quantidade: number;
  valorExecutado: number;
  valorCotado: number;
  isExecutado: boolean;
  forca: Forca;
}

export default function DashboardAsplan() {

  const [isCarregando, setIsCarregando] = useState(false)
  const [dados, setDados] = useState({
    dataFim: new Date(),
    dataInicio: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    idProjeto: null
  })
  const [dadosDashCotados, setDadosDashCotados] = useState<DadosDash[]>([])
  const [dadosDashExecutados, setDadosDashExecutados] = useState<DadosDash[]>([])
  const [valoresForca, setValoresForca] = useState<any>({})
  const [forcas, setForcas] = useState<Forca[]>([])
  const [dadosPizza, setDadosPizza] = useState<PieChartCell[]>([{name: "FORÇA", value: 1, color: COR.PRIMARIO}])
  const [dadosBarra, setDadosBarra] = useState<Record<string, any>[]>([{forca: "FORÇAS", FORCA: 1}])
  const [seriesBarra, setSeriesBarra] = useState<BarChartSeries[]>([{name: "FORCA", color: COR.PRIMARIO},]);

  const [checkedBadge, setCheckedBadge] = useState<any>("");

  function buscar() {
    setIsCarregando(true)
    const forcasServico = ForcaServico.buscarForcas()
    let url = dados.idProjeto !== null
      ? `/dashboard?dataInicio=${dados.dataInicio.toLocaleDateString(LOCAL_DATE_STRING)}&dataFim=${dados.dataFim.toLocaleDateString(LOCAL_DATE_STRING)}&idProjeto=${dados.idProjeto}`
      : `/dashboard?dataInicio=${dados.dataInicio.toLocaleDateString(LOCAL_DATE_STRING)}&dataFim=${dados.dataFim.toLocaleDateString(LOCAL_DATE_STRING)}&idProjeto=`
    xfetch(url, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(dados => {
        setDadosDashCotados(dados.itensEmpenhados)
        setDadosDashExecutados(dados.itensExecutados)
        setValoresForca(dados.valoresPorForca)

        let pizza: PieChartCell[] = []
        let barra: any
        let check: any
        let series: BarChartSeries[] = []

        forcasServico.then(fs => {
          setForcas(fs)
          fs.map((f) => {
            pizza.push({name: f.sigla, value: dados.valoresPorForca[f.sigla], color: f.cor})
            series.push({name: f.sigla, color: f.cor})
            check = {...check, [f.sigla]: true};
            barra = {...barra, [f.sigla]: dados.valoresPorForca[f.sigla]};
          })
          setDadosPizza(pizza)
          setDadosBarra([{forca: "FORCAS", ...barra}])
          setSeriesBarra(series)
          setCheckedBadge(check)
        })
      })
      .finally(() => setIsCarregando(false))
  }

  function toggle(f: string, checked: boolean) {
    const forca = getForca(f, forcas);
    if (checked) {
      setDadosPizza(dadosPizza.filter((i: PieChartCell) => i.name !== forca.sigla))
      setSeriesBarra(seriesBarra.filter((i: BarChartSeries) => i.name !== forca.sigla))
    } else {
      const pizza = dadosPizza;
      const barra = seriesBarra;
      const valorForca = valoresForca[forca.sigla]
      pizza.push({name: forca.sigla, value: valorForca, color: forca.cor})
      barra.push({name: forca.sigla, color: forca.cor})
      setDadosPizza(pizza)
      setSeriesBarra(barra)
    }
    setCheckedBadge({...checkedBadge, [forca.sigla]: !checked})
  }

  function Colunas() {
    return useMemo<MRT_ColumnDef<DadosDash>[]>(
      () => [
        {
          accessorKey: 'nome',
          header: 'Descrição',
          filterVariant: 'autocomplete',
        }, {
          accessorKey: 'quantidade',
          header: 'Quantidade',
          filterVariant: 'range',
          filterFn: 'betweenInclusive',
        },
        {
          id: 'pUnitario',
          header: 'P. Unitário',
          accessorFn: (row) => row.isExecutado ? row.valorExecutado : row.valorCotado,
          Cell: ({cell}) =>
            formatarDinheiroItl(cell.getValue()),
          filterVariant: 'range',
          filterFn: 'betweenInclusive',
        },
        {
          id: 'pTotal',
          header: 'P. Total',
          accessorFn: (row) => {
            return row.isExecutado ? row.quantidade * row.valorExecutado
              : row.quantidade * row.valorCotado;
          },
          Cell: ({cell}) => formatarDinheiroItl(cell.getValue()),
          filterVariant: 'range',
          filterFn: 'betweenInclusive',
        },
        {
          accessorKey: 'forca.sigla',
          header: 'Forca',
          Cell: ({renderedCellValue, row}) => (
            <Tooltip label={row.original.forca.nome}>
              <Badge color={row.original.forca.cor}>
                {renderedCellValue}
              </Badge>
            </Tooltip>
          ),
          filterVariant: 'multi-select',
        },
      ], [])
  }

  function getBadgesForca() {
    return (
      forcas.map((f, k) => {
        const forca = getForca(f.sigla, forcas)
        return (
          <Tooltip label={forca.sigla} key={k}>
            <Chip m={5} className={"shadow-md"} checked={checkedBadge[forca.sigla]}
                  onClick={() => toggle(forca.sigla, checkedBadge[forca.sigla])}
                  color={forca.cor}>{forca.nome}: {formatarDinheiroItl(valoresForca[forca.sigla])}</Chip>
          </Tooltip>
        )
      })
    )
  }

  useEffect(() => {
    buscar()
  }, []);

  return (
    <PaginaLogada titulo="Asplan em números" isCarregando={isCarregando} botaoVoltar={true}>
      <Card withBorder shadow="sm" radius="md">
        <Card.Section withBorder inheritPadding py="xs">
          <Text fw={500}>Dashboard</Text>
        </Card.Section>
        <Card.Section p={"md"}>
          <Grid>
            <Grid.Col span={COL_RESP_3}>
              <DateInput
                label="Data inicio"
                placeholder="DD/MM/AAAA"
                clearable
                valueFormat="DD/MM/YYYY"
                value={dados.dataInicio}
                onChange={(e) => setDados({...dados, dataInicio: new Date(e!!)})}
              />
            </Grid.Col>
            <Grid.Col span={COL_RESP_3}>
              <DateInput
                label="Data fim"
                placeholder="DD/MM/AAAA"
                clearable
                valueFormat="DD/MM/YYYY"
                value={dados.dataFim}
                onChange={(e) => setDados({...dados, dataFim: new Date(e!!)})}
              />
            </Grid.Col>
            <Grid.Col span={COL_RESP_3}>
              <SelectFetchMantine
                label={"Fundo:"}
                url={"/projeto/fundo-a-fundo"}
                placeholder={"Selecione o fundo"}
                onChange={(e: any) => {
                  setDados({...dados, idProjeto: (e)})
                }}/>
            </Grid.Col>
            <Grid.Col span={COL_RESP_3} style={{alignSelf: 'flex-end'}}>
              <Button
                leftSection={<IconSearch/>}
                onClick={buscar}>
                Buscar
              </Button>
            </Grid.Col>
          </Grid>
        </Card.Section>
      </Card>
      <Card withBorder shadow="sm" radius="md" my={"sm"}>
        <Grid>
          <Grid.Col span={12}>
            <Title order={4} my={20}>Valores por Força</Title>
          </Grid.Col>
          <Grid.Col span={6}>
            <Center>
              <PieChart
                w={"100%"}
                data={dadosPizza}
                withLabels
                withTooltip
                valueFormatter={formatarDinheiroItl}
                tooltipDataSource="segment"
                className={"shadow-md"}
              />
            </Center>
          </Grid.Col>
          <Grid.Col span={6}>
            <BarChart
              h={300}
              data={dadosBarra}
              dataKey={"forca"}
              xAxisProps={{width: 10}}
              valueFormatter={formatarDinheiroItl}
              withLegend
              series={seriesBarra}
              className={"shadow-md"}
            />
          </Grid.Col>
        </Grid>
      </Card>
      <Grid>
        <Grid.Col span={12}>
          <Center>
            <Group>
              {getBadgesForca()}
            </Group>
          </Center>
        </Grid.Col>
      </Grid>

      <Divider size={10} color={"blue.9"} my={30} labelPosition={"center"}
               label={<Title order={3} c={"black"}>Descrição dos Valores</Title>} styles={{
        root: {
          borderColor: 'linear-gradient(45deg, var(--mantine-color-blue-filled) 0%, var(--mantine-color-indigo-filled) 100%',
          borderRadius: '50px'
        },
      }}
      />

      <Tabs variant={"unstyled"} defaultValue="itensExecutados" mb={50} mt={10} classNames={classes}>
        <Tabs.List grow>
          <Tabs.Tab value="itensExecutados" color={COR.PRIMARIO} leftSection={<IconFileDollar/>} fz={15}>
            Valores Executados
          </Tabs.Tab>
          <Tabs.Tab value="itensCotados" color={COR.ALERTA} leftSection={<IconFileAlert/>} fz={15}>
            Valores Empenhados
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="itensExecutados">
          <MantineReactTable
            data={dadosDashExecutados}
            columns={Colunas()}
            enablePagination
            enableFacetedValues={true}
            initialState={{showColumnFilters: true}}
            localization={MRT_Localization_PT_BR}
          />
        </Tabs.Panel>

        <Tabs.Panel value="itensCotados">
          <MantineReactTable
            data={dadosDashCotados}
            columns={Colunas()}
            enablePagination
            enableFacetedValues={true}
            initialState={{showColumnFilters: true}}
            localization={MRT_Localization_PT_BR}
          />
        </Tabs.Panel>
      </Tabs>
    </PaginaLogada>
  )
}
